import React from 'react';
import { useAppStore } from '../../store';
import { X, Info, CheckCircle, AlertTriangle, AlertCircle } from 'lucide-react';

export const Toasts: React.FC = () => {
  const { notifications, removeNotification } = useAppStore();

  if (notifications.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 w-full max-w-sm pointer-events-none">
      {notifications.map((note) => (
        <div 
          key={note.id}
          className="pointer-events-auto bg-white rounded-lg shadow-lg border border-slate-100 p-4 flex items-start gap-3 animate-in slide-in-from-right-1/2 duration-300"
        >
          <div className={`mt-0.5 ${
            note.type === 'success' ? 'text-emerald-500' :
            note.type === 'warning' ? 'text-amber-500' :
            note.type === 'error' ? 'text-red-500' :
            'text-blue-500'
          }`}>
            {note.type === 'success' && <CheckCircle size={18} />}
            {note.type === 'warning' && <AlertTriangle size={18} />}
            {note.type === 'error' && <AlertCircle size={18} />}
            {note.type === 'info' && <Info size={18} />}
          </div>
          
          <div className="flex-1">
            <p className="text-sm font-medium text-slate-800 leading-snug">{note.message}</p>
            <p className="text-[10px] text-slate-400 mt-1">Just now</p>
          </div>

          <button 
            onClick={() => removeNotification(note.id)}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};